import * as React from 'react';

import VersionNumber from '../VersionNumber';

import { LoginByPasswordFooterProps } from '@shopee-user/business-customization-types';

export default function LoginByPasswordFooter({
  footerClassName,
}: LoginByPasswordFooterProps) {
  return (
    <div className={footerClassName}>
      <VersionNumber />
    </div>
  );
}
